import React, { useEffect, useCallback } from 'react';
import { useMercadopago } from 'react-sdk-mercadopago';
import { mercadopagoPK } from '../../../config';
import { createPreference } from '../../../_apis_/pagos';
import PropTypes from 'prop-types';
import { analytics } from '../../../contexts/FirebaseContext';
import { analyticsEvents } from '../../../constants/analyticsEvents';

ButtonRecargaMercPago.propTypes = {
  elementId: PropTypes.string,
  label: PropTypes.string,
  items: PropTypes.array,
  amount: PropTypes.string
};

export default function ButtonRecargaMercPago({
  elementId = 'button-merc',
  label = 'Comprar',
  items = [],
  amount = ''
}) {
  const merc = useMercadopago.v2(mercadopagoPK, { locale: 'es-MX' });
  console.log('los items', items);
  const checkout = useCallback(
    async (data) => {
      try {
        document.getElementById(elementId).innerHTML = '';
        const payID = await createPreference(data, {
          success: `${window.location.origin}/dashboard/paquetes/envios?medio_pago=mercadoPago&tipo_pago=recarga&amount=${amount}`,
          pending: `${window.location.origin}/dashboard/paquetes/envios`,
          failure: `${window.location.origin}/dashboard/paquetes/envios`
        });
        merc.checkout({
          preference: {
            id: payID
          },
          render: {
            container: `#${elementId}`,
            label
          }
        });
      } catch (err) {
        console.error(err.response);
      }
    },
    [elementId, merc, label, amount]
  );

  const calculartotal = useCallback(() => {
    let total = 0;
    items.forEach((item) => {
      total += item.price * item.quantity;
    });
    return total;
  }, [items]);

  useEffect(() => {
    checkout(items);
  }, [checkout, items]);

  return (
    <div
      id={elementId}
      onClickCapture={() => {
        analytics.logEvent(analyticsEvents.click_mercado_pago_checkoutPro, {
          label: 'pago_mercado_pago',
          value: calculartotal()
        });
      }}
    >
      {' '}
    </div>
  );
}
